'use strict';

const linkSelector = '.global-nav__link';
const itemSelector = '.global-nav__item';
const itemListSelector = '.global-nav__child';
const backSelector = '.global-nav__item--back';
const itemActiveClass = 'global-nav__item--active';
const parentActiveClass = 'is-active';
const menuActiveClass = 'nav-open-inverted';
const menuBtnId = 'nav-btn';
const menuFeature = '.js-menu-feature';

export function calculateFeatureHeight() {
    let featureHeight = 20;

    const menuFeatureItem = document.querySelector(menuFeature);

    if (!menuFeatureItem) {
        return false;
    }

    featureHeight = menuFeatureItem.getBoundingClientRect().height;

    document.documentElement.style.setProperty('--navigation-feature-height', `${featureHeight}px`);

    window.addEventListener('resize', () => {
        featureHeight = menuFeatureItem.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--navigation-feature-height', `${featureHeight}px`);
    });
}

export function init() {
    const links = document.querySelectorAll(linkSelector);
    const backLinks = document.querySelectorAll(backSelector);
    const menuBtn = document.getElementById(menuBtnId);

    if (!links.length) {
        return;
    }

    links.forEach(link => {
        if (link.nextElementSibling) {
            link.nextElementSibling.addEventListener('click', () => process(link));
        }
    });

    backLinks.forEach(backLink => {
        backLink.addEventListener('click', () => backProcess(backLink));
    });

    if(menuBtn) {
        menuBtn.addEventListener('click', () => resetMenu(links));
    }

    process_active_menu();

    calculateFeatureHeight();
}

function resetMenu(links) {
    setTimeout( () => {
        links.forEach(link => {
            link.closest('ul').querySelectorAll(itemSelector).removeClass(itemActiveClass);
            link.closest('ul').classList.remove(parentActiveClass);
            document.body.classList.remove(menuActiveClass);
        });
     }, 250);
}

function process(link) {
    link.closest('ul').querySelectorAll(itemSelector).removeClass(itemActiveClass);
    link.closest('li').classList.add(itemActiveClass);

    document.body.classList.add(menuActiveClass);

    if (link.nextElementSibling) {
        link.closest('ul').classList.add(parentActiveClass);
        link.nextElementSibling.nextElementSibling.classList.remove(parentActiveClass);
    } else {
        link.closest('ul').classList.remove(parentActiveClass);
    }
}

function backProcess(backLink) {
    backLink.closest('.global-nav__item.has-child').classList.remove(itemActiveClass);
    backLink.closest('.global-nav__item.has-child').closest('ul').classList.remove(parentActiveClass);

    if(backLink.parentElement.classList.contains('global-nav--level-1')) {
        document.body.classList.remove(menuActiveClass);
    }
}

function process_active_menu () {
    const link = location.href.replace(location.origin, '');
    const linkObj = document.querySelector(`a.global-nav__link[href='${link}']`);
    if (!linkObj) return;

    linkObj.classList.add('active');

    let currentUL = linkObj.closest(itemListSelector);
    let upperLI = currentUL ? currentUL.closest(itemSelector) : null;

    while (currentUL && upperLI) {
        upperLI.classList.add(itemActiveClass);
        upperLI.parentNode.classList.add(parentActiveClass);

        currentUL = upperLI.closest(itemListSelector);
        upperLI = currentUL ? currentUL.closest(itemSelector) : null;
    }

    // Handle the desktop nav active
    const desktopLinkObj = document.querySelector(`a.desktop-navigation__link[href='${link}']`);
    if (desktopLinkObj) {
        const parentLi = desktopLinkObj.closest('.desktop-navigation__item');

        if (parentLi) {
        parentLi.classList.add('desktop-navigation__item--active');
        }

        desktopLinkObj.classList.add('active');
    }
}
